import { getCachedPortalData } from '../api/portal'
import { getMockUserData } from '../api/mock'

/**
 * Portal 数据统一入口，供 Home 等页面使用
 * 后端不可用时静默 fallback 到空数据（不再内嵌 mock 游戏列表）
 */

function emptyPortal() {
  return {
    games: [], allGames: [], gamesById: {},
    banners: [], marquees: [],
    frequentGames: [], recommendGames: [],
    featuredMods: [], normalMods: [],
    featuredModGames: [], normalModGames: [],
    categories: [], categoryGamesMap: {}
  }
}

export function loadFullPortalData(userId) {
  return getCachedPortalData(userId).catch(function() { return emptyPortal() })
}

export function loadUserData() {
  return getMockUserData()
}
